import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, Loader2 } from "lucide-react";
import { adminLogin } from "../lib/adminApi";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await adminLogin(email, password);
      navigate("/admin");
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-black flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
        className="w-full max-w-md"
      >
        <div className="flex items-center gap-1 justify-center mb-2">
          <span className="font-serif text-3xl">A+Auto</span>
          <span className="text-[#FFD400] font-serif text-3xl">Fleet</span>
        </div>
        <p className="text-center text-white/40 text-xs uppercase tracking-[0.3em] mb-10">Admin Console</p>

        <form onSubmit={submit} className="border border-white/10 bg-[#0B0B0B] p-8 rounded-2xl">
          <div className="flex items-center gap-2 text-[#FFD400] mb-6">
            <Lock size={18} /> <span className="text-sm uppercase tracking-wider">Secure Sign In</span>
          </div>

          {error && (
            <div data-testid="login-error" className="bg-red-500/10 border border-red-500/40 text-red-300 text-sm px-4 py-3 mb-5 rounded-lg">
              {error}
            </div>
          )}

          <label className="block text-white/50 text-xs uppercase tracking-wider mb-2">Email</label>
          <input
            data-testid="admin-email-input"
            type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
            className="w-full bg-black border border-white/15 rounded-lg px-4 py-3 mb-5 text-white focus:outline-none focus:border-[#FFD400]"
            placeholder="admin@aplusauto.com"
          />
          <label className="block text-white/50 text-xs uppercase tracking-wider mb-2">Password</label>
          <input
            data-testid="admin-password-input"
            type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
            className="w-full bg-black border border-white/15 rounded-lg px-4 py-3 mb-7 text-white focus:outline-none focus:border-[#FFD400]"
            placeholder="••••••••"
          />
          <button
            data-testid="admin-login-btn"
            type="submit" disabled={loading}
            className="w-full bg-[#FFD400] text-black font-medium py-3 rounded-lg hover:bg-[#e6c000] transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading ? <><Loader2 size={16} className="animate-spin" /> Signing in…</> : "Sign In"}
          </button>
        </form>
        <p className="text-center text-white/30 text-xs mt-6">Authorized personnel only.</p>
      </motion.div>
    </div>
  );
}
